import { RemixBrowser } from "@remix-run/react";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { I18nextProvider, initReactI18next } from "react-i18next";
import { getInitialNamespaces } from "remix-i18next/client";
import i18n from "./i18n/i18n";
import { NonceProvider } from "./utils/nonce-provider.ts";

if (ENV.MODE === "production" && ENV.SENTRY_DSN) {
  void import("./utils/monitoring.client.tsx").then(({ init }) => init());
}

if (ENV.MODE === "production" && ENV.AMPLITUDE_API_KEY) {
  void import("./utils/amplitude.client.ts").then(({ initAmplitude }) =>
    initAmplitude(),
  );
}

const envScript = document.getElementById("env-script");
const nonce = envScript?.getAttribute("nonce") ?? "";

async function hydrate() {
  await i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(Backend)
    .init({
      ...i18n,
      ns: getInitialNamespaces(),
      backend: { loadPath: "/locales/{{lng}}/{{ns}}.json" },
      detection: {
        order: ["htmlTag"],
        caches: [],
      },
    });

  startTransition(() => {
    hydrateRoot(
      document,
      <I18nextProvider i18n={i18next}>
        {/* Must mirror entry.server.tsx: antd styles injected at runtime need the
				    same `@layer antd` wrapper, otherwise they outrank Tailwind v4 utilities. */}
        <StrictMode>
          <NonceProvider value={nonce}>
            <RemixBrowser />
          </NonceProvider>
        </StrictMode>
      </I18nextProvider>,
    );
  });
}

void hydrate();
